import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrmServiceModel } from 'shared/models';
import { OrganizationType } from 'shared/services';

@Injectable()
export class InvitationService {
    constructor(private crmServiceModel: CrmServiceModel) {}

    public getInvitation(token: string): Observable<Invitation> {
        return this.crmServiceModel.makeHttpObservableRequest<Invitation>({
            method: 'GET',
            url: `${this.crmServiceModel.getInvitationsEndpoint()}/by-token/${encodeURIComponent(token)}`
        });
    }

    public signup({
        token,
        termsAccepted,
        marketingEmailConsentAccepted,
        user
    }: {
        token: string;
        marketingEmailConsentAccepted: boolean;
        termsAccepted: true;
        user: {
            firstname: string;
            surname: string;
            password?: string;
        };
    }) {
        return this.crmServiceModel.makeHttpObservableRequest<null>({
            method: 'POST',
            url: `${this.crmServiceModel.getInvitationsEndpoint()}/by-token/${encodeURIComponent(token)}/acceptance`,
            body: {
                firstname: user.firstname,
                surname: user.surname,
                termsAccepted,
                marketingEmailConsentAccepted
            }
        });
    }

    public requestTeamInvite(data: {
        organizationId: string;
        firstName: string;
        lastName: string;
        email: string;
        preferredLanguage: string;
    }) {
        return this.crmServiceModel.makeHttpObservableRequest<null>({
            method: 'POST',
            url: `${this.crmServiceModel.getInvitationsEndpoint()}/request`,
            body: data
        });
    }
}

export interface Invitation {
    _id?: string;
    inviteeEmail: string;
    organization: {
        _id?: string;
        name: string;
        type: OrganizationType;
        address?: {
            line1: string;
            zip: string;
            city: string;
            country: string;
        };
    };
    token: string;
}
